import type { OfferPlanClientDetails } from '@avalara/types/offers';

export const getOfferPlanPrice = (plan: OfferPlanClientDetails | null | undefined): number =>
  plan?.productItems?.reduce((total, { price }) => total + price, 0) ?? 0;
